import { isMobile } from 'react-device-detect';

export const userEnvironment = {
  isMobileWeb: isMobile && !window.ReactNativeWebView,
  isMobileApp: isMobile && !!window.ReactNativeWebView,
  isPC: !isMobile && !window.ReactNativeWebView,
};
